module.exports = __webpack_public_path__ + "static/img/larvicide.393769a.svg";